<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box register">
            <div class="container register step2">
                <div class="title">
                    <h1 v-if="showView('requestRepairInfo')">{{ $t('TITLE.REQUEST.REPAIR.INFORMATION') }}</h1>
                    <h1 v-if="showView('requestQuestion')">{{ $t('TITLE.VOC.QUESTION') }}</h1>
                </div>
                <div class="content" ng-init="">
                    <div class="one-register">
                        <keep-alive>
                            <req-repair-info v-if="showView('requestRepairInfo')" :bIndependent="false" />
                            <req-question v-if="showView('requestQuestion')" :bIndependent="false" />
                        </keep-alive>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { SDLUtil, StringUtil } from '@/utils';
import qs from 'query-string';
import axios from 'axios';
import constants from '@/constants';
import store from '@/vuex/store';
import RequestRepairInfo from '~vb/eur/user/RequestRepairInfo';
import RequestQuestion from '~vb/eur/voc/RequestQuestion';
import { i18n, loadLanguageAsync } from '@/i18n';

export default {
    name: 'EurUserMain',
    components: {
        'req-repair-info': RequestRepairInfo,
        'req-question': RequestQuestion,
    },
    computed: {
        ...mapGetters({
            loginId: 'getLoginId',
            corpNo: 'getCorpNo',
            langCd: 'getLangCd',
            countryCd: 'getCountryCd',
        }),
    },
    data() {
        return {
            modelList: [],
            contentsList: [],
            selectModelCode: '',
            selectProductCategory: '',
        };
    },
    methods: {
        showView(v) {
            let result = false;
            if (this.$route.name === v) {
                result = true;
            }
            return result;
        },
        goLoginPage() {
            this.$nextTick(() => {
                SDLUtil.alert({
                    title: 'MESSAGE.AUTH.NOAUTH',
                    msg: 'MESSAGE.SESSION.HAS.EXPIRED',
                    onOkEvt: () => {
                        this.$router.push({
                            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`,
                            query: { countryCd: this.countryCd, langCd: this.langCd },
                        });
                    },
                });
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (SDLUtil.isEurLogin()) {
                loadLanguageAsync(this.langCd);
                $('body').addClass('reaair_wrap');
            } else {
                this.goLoginPage();
            }
        });
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/EurUserMain.vue